import React, { Fragment, useState, useEffect } from 'react';
import "./UpdateProfile.css";
import { CiMail } from "react-icons/ci";
import { BiUserCircle } from "react-icons/bi";
import { useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { updateProfile, clearErrors, loadUser } from '../../actions/userAction';
import Loader from '../layout/Loader/Loader';
import { updateProfileReset } from '../../reducers/userReducer';
import MetaData from '../layout/MetaData';
import { toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css';

const UpdateProfile = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { user } = useSelector((state) => state.user);
    const { error, isUpdated, loading } = useSelector((state) => state.profile);
    console.log("user in UpdateProfile : ", user);
    // console.log(isUpdated);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [avatar, setAvatar] = useState();
    const [avatarPreview, setAvatarPreview] = useState("/Profile.png");

    const updateProfileSubmit = (e) => {
        e.preventDefault();

        const myForm = new FormData();

        myForm.set("name", name);
        myForm.set("email", email);
        if(avatar){
            myForm.set("avatar", avatar);
        }
        if(error)
            console.log("getting error while updating profile : ",error);
        dispatch(updateProfile(myForm));
    };

    const updateProfileDataChange = (e) => {
        const reader = new FileReader();

        reader.onload = () => {
            if (reader.readyState === 2) {
                setAvatarPreview(reader.result);
                setAvatar(reader.result);
            }
        };

        reader.readAsDataURL(e.target.files[0]);
    };

    useEffect(() => {
        if (user) {
            setName(user?.user?.name);
            setEmail(user?.user?.email);
            setAvatarPreview(user?.user?.avatar?.url);
        }

        if (error) {
            console.log("inside UpdateProfile.js : ",error);
            // toast.error(error);
            dispatch(clearErrors());
        }

        if (isUpdated) {
            toast.success("Profile Updated Successfully");
            dispatch(loadUser());

            navigate("/account");

            dispatch(updateProfileReset());
        }
    }, [dispatch, error, navigate, user, isUpdated]);


    return (
        <Fragment>
            {loading ? <Loader /> : 
            <Fragment>
                <MetaData title="Update Profile" />
                <div className="updateProfileContainer">
                    <div className="updateProfileBox">
                        <h2 className="updateProfileHeading">Update Profile</h2>

                        <form
                            className="updateProfileForm"
                            encType="multipart/form-data"
                            onSubmit={updateProfileSubmit}
                        >
                            <div className="updateProfileName">
                                <BiUserCircle />
                                <input
                                    type="text"
                                    placeholder="Name"
                                    required
                                    name="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            <div className="updateProfileEmail">
                                <CiMail />
                                <input
                                    type="email"
                                    placeholder="Email"
                                    required
                                    name="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>

                            <div id="updateProfileImage">
                                <img src={avatarPreview} alt="Avatar Preview" />
                                <input
                                    type="file"
                                    name="avatar"
                                    accept="image/*"
                                    onChange={updateProfileDataChange}
                                />
                            </div>
                            <input
                                type="submit"
                                value="Update"
                                className="updateProfileBtn"
                            />
                        </form>
                    </div>
                </div>
            </Fragment>}
        </Fragment>
    )
}

export default UpdateProfile